import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";

interface CookieBannerProps {
  onAcceptAll: () => void;
  onRejectAll: () => void;
  onManage: () => void;
}

export function CookieBanner({
  onAcceptAll,
  onRejectAll,
  onManage
}: CookieBannerProps) {
  const { t } = useTranslation("common");

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 p-4 bg-background/80 backdrop-blur-sm border-t shadow-lg">
      <div className="container mx-auto max-w-7xl flex flex-col md:flex-row items-center justify-between gap-4">
        <div className="flex-1 text-sm text-foreground/80">
          <p>{t("cookies.banner.text")}</p>
        </div>
        <div className="flex flex-col sm:flex-row gap-3 w-full md:w-auto">
          <Button variant="outline" size="sm" onClick={onManage}>
            {t("cookies.banner.manage")}
          </Button>
          <Button variant="outline" size="sm" onClick={onRejectAll}>
            {t("cookies.banner.reject_all")}
          </Button>
          <Button size="sm" onClick={onAcceptAll}>
            {t("cookies.banner.accept_all")}
          </Button>
        </div>
      </div>
    </div>
  );
}
